"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.OneMediaOverlayTextLayout = void 0;
var _editorialFetching = require("@ori/editorial-fetching");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _utils = require("../../utils");
var _shared = require("../shared");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const OneMediaOverlayTextLayout = (param)=>{
    let { banner, debug, position, modulePosition, className } = param;
    const { getTestId } = (0, _testidGenerator.default)();
    const { modules, layout, id } = banner;
    if (modules == null || modules.length < 1) {
        return (0, _utils.getModulesContentAndLengthError)({
            debug,
            layout,
            modulePosition
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.Root, {
        "data-testid": getTestId(position === 'left' ? _editorialFetching.EditorialBannerLayoutEnum.OneMediaOverlayLeftText : _editorialFetching.EditorialBannerLayoutEnum.OneMediaOverlayRightText),
        position: position,
        className: className,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_shared.ImageBox, {
                id: id,
                module: modules[0],
                imageParams: _constants.IMAGE_PARAMS.params,
                sizes: _constants.IMAGE_PARAMS.sizes,
                height: _constants.IMAGE_DESKTOP_HEIGHT,
                width: _constants.IMAGE_DESKTOP_WIDTH
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.TextWrapper, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.TextBoxWithDesktopGap, {
                    titleMaxLines: 3,
                    titleVariant: "h4",
                    module: modules[1]
                })
            })
        ]
    });
};
exports.OneMediaOverlayTextLayout = OneMediaOverlayTextLayout;
